import { useTranslation } from "react-i18next";
import BuyButton from "../buttons/BuyButton";

const ImgTextCard = ({
  id,
  img,
  img_width,
  title,
  details,
  buy_link,
  text_instead_of_buy_link,
  renderBody,
}) => {
  const { t } = useTranslation();

  const replacePlaceholders = (str, t) => {
    if (!str) return "";
    return str.replace(/\$t\(([^)]+)\)/g, (_, key) => t(key));
  };

  return (
    <div className="card cd-showcase-card border-0 shadow-sm rounded-4 p-4 mb-4 bg-white" key={id}>
      <div className="row align-items-center g-4">
        <div className="col-md-4 col-lg-3 text-center">
          <div className="cd-cover-wrapper position-relative d-inline-block">
            <img
              src={img}
              alt={title}
              className="img-fluid rounded-3 shadow cd-cover-image"
              style={{ maxHeight: "240px", objectFit: "cover" }}
              loading="lazy"
            />
          </div>
        </div>

        <div className="col-md-8 col-lg-9">
          <h4 className="cd-title-text mb-3">
            {title}
          </h4>

          <div className="cd-details-text text-muted mb-3">
            {renderBody(replacePlaceholders(details, t))}
          </div>

          <div className="cd-action-bar d-flex align-items-center justify-content-between pt-3 border-top flex-wrap gap-2">
            {buy_link ? (
              <BuyButton href={buy_link} text={t("disc.buy_btn")} />
            ) : (
              <span className="text-muted small fst-italic">
                {text_instead_of_buy_link || ""}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImgTextCard;
